<div id="background-operations-drawer-container" #BackgroundOperationsDrawerContainer *ngIf="Operations$ | async as operations">
	<crownx-icon-button
		(Clicked)="BackgroundOperationsDrawer.toggle()"
		AriaLabel="Open Processing Operations"
		[ShowProcessingBar]="GetProcessingCount(operations) > 0"
		[BadgeCount]="GetProcessingCount(operations)"
	>
		notifications
	</crownx-icon-button>
		<mat-sidenav-container>
			<mat-sidenav
				#BackgroundOperationsDrawer
				id="background-operations-drawer"
				position="end"
				mode="over"
				class="drawer"
				[fixedInViewport]="true"
				[fixedTopGap]="76"
			>
				<div id="background-operations-drawer-header" class="drawer-header">
					<h3>Processing Operations</h3>
					<crownx-icon-button (Clicked)="BackgroundOperationsDrawer.close()" AriaLabel="Close Processing Operations">
						close
					</crownx-icon-button>
				</div>
				<mat-divider></mat-divider>
				<div id="background-operations-drawer-content" class="drawer-content">
					<crownx-background-operations-list [BackgroundOperations]="operations" (OperationClicked)="OnBackgroundOperationClick($event)"></crownx-background-operations-list>
				</div>
			</mat-sidenav>
		</mat-sidenav-container>
</div>